import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { format as formatDate } from 'date-fns';
import { useIoContext } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { validateBundles, validateDayOfMonth, validateDiscountPeriodExpiration, validateIntegratedClass, validateLimitedTimeDiscountOffer, validateMaxCharges, validateOneTimeInStages, validatePreapprovedAmount, validatePriceIncrease, validateStartBillingAt, serviceValidationTextsPath } from '../logic';
import { isFromAmendment } from '../selectors';
import { resolveStageScheduleContext } from '../stageScheduleContext';
const resolveScheduleContext = (service, opts)=>({
        context: resolveStageScheduleContext({
            isTemplate: opts.isTemplate,
            isAmendment: isFromAmendment(service),
            effectiveDate: opts.relationshipEffectiveDate,
            now: opts.now,
            isExistingService: opts.isExistingService
        }),
        effectiveDate: opts.relationshipEffectiveDate ? formatDate(opts.relationshipEffectiveDate, 'yyyy-MM-dd') : null,
        today: formatDate(opts.now, 'yyyy-MM-dd')
    });
export const useValidateService = ()=>{
    const { getNow } = useIoContext();
    const { t: validationTexts } = useLocaleKeys(serviceValidationTextsPath);
    const validate = (service, opts)=>{
        var _opts_isTemplate, _opts_isExistingService, _opts_proposalCreatedOn;
        const scheduleContext = resolveScheduleContext(service, {
            isTemplate: (_opts_isTemplate = opts.isTemplate) !== null && _opts_isTemplate !== void 0 ? _opts_isTemplate : false,
            relationshipEffectiveDate: opts.relationshipEffectiveDate,
            now: opts.now,
            isExistingService: (_opts_isExistingService = opts.isExistingService) !== null && _opts_isExistingService !== void 0 ? _opts_isExistingService : false
        });
        return [
            ...validateMaxCharges(service, validationTexts),
            ...opts.excludeBillingValidation ? [] : validateDayOfMonth(service, validationTexts),
            ...validatePriceIncrease(service, opts, validationTexts),
            ...validateIntegratedClass(service, validationTexts),
            ...validateLimitedTimeDiscountOffer(service, opts.now, validationTexts, (_opts_proposalCreatedOn = opts.proposalCreatedOn) !== null && _opts_proposalCreatedOn !== void 0 ? _opts_proposalCreatedOn : null),
            ...validateOneTimeInStages(service, scheduleContext),
            ...validateDiscountPeriodExpiration(service, opts.now, validationTexts, opts.relationshipEffectiveDate),
            ...validatePreapprovedAmount(service, validationTexts),
            ...validateBundles(service),
            ...validateStartBillingAt(service, opts, validationTexts)
        ];
    };
    return {
        isInvalid: (service, opts)=>{
            const errors = validate(service, _object_spread_props(_object_spread({}, opts), {
                now: getNow()
            }));
            return errors.length > 0;
        },
        isLimitedTimeDiscountOfferInvalid: (service, proposalCreatedOn)=>!!validateLimitedTimeDiscountOffer(service, getNow(), validationTexts, proposalCreatedOn)
    };
};
